<div class="round-checkbox" [class.selected]="params.node.selected">
    <i class="fas fa-check-circle"></i>
</div>
